// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "log/v1/log.proto" (package "log.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private logs RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../google/protobuf/struct";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * Duplicated from go.viam.com/api/common/v1 because proto imports must be relative.
 * Remove this unnecessary duplicate definition when this endpoint moves to api repo
 *
 * @generated from protobuf message log.v1.LogEntry
 */
export interface LogEntry {
    /**
     * @generated from protobuf field: string host = 1;
     */
    host: string;
    /**
     * @generated from protobuf field: string level = 2;
     */
    level: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time = 3;
     */
    time?: Timestamp;
    /**
     * @generated from protobuf field: string logger_name = 4;
     */
    loggerName: string;
    /**
     * @generated from protobuf field: string message = 5;
     */
    message: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct caller = 6;
     */
    caller?: Struct;
    /**
     * @generated from protobuf field: string stack = 7;
     */
    stack: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Struct fields = 8;
     */
    fields: Struct[];
}
/**
 * @generated from protobuf message log.v1.GetLogsForMachinePartResourceRequest
 */
export interface GetLogsForMachinePartResourceRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: repeated string sources = 2;
     */
    sources: string[];
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp start_time = 3;
     */
    startTime?: Timestamp;
}
/**
 * @generated from protobuf message log.v1.GetLogsForMachinePartResourceResponse
 */
export interface GetLogsForMachinePartResourceResponse {
    /**
     * @generated from protobuf field: repeated log.v1.LogEntry logs = 1;
     */
    logs: LogEntry[];
}
/**
 * @generated from protobuf message log.v1.GetRobotPartLogsRequest
 */
export interface GetRobotPartLogsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: optional string filter = 2;
     */
    filter?: string;
    /**
     * @generated from protobuf field: optional string page_token = 3;
     */
    pageToken?: string;
    /**
     * logs of all levels are returned when the levels field is empty
     *
     * @generated from protobuf field: repeated string levels = 4;
     */
    levels: string[];
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp start = 5;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp end = 6;
     */
    end?: Timestamp;
    /**
     * @generated from protobuf field: optional int64 limit = 7;
     */
    limit?: string;
    /**
     * logs of all sources are returned when the sources field is empty
     *
     * @generated from protobuf field: repeated string sources = 8;
     */
    sources: string[];
    /**
     * @generated from protobuf field: optional bool user_facing_only = 9;
     */
    userFacingOnly?: boolean;
    /**
     * logs are returned newest first when the order field is empty
     *
     * @generated from protobuf field: optional log.v1.LogOrder order = 10;
     */
    order?: LogOrder;
    /**
     * range is a duration string in minutes, hours, or days (e.g. "10m", "10h", "10d")
     * that is resolved against whichever of start and end is present:
     *
     *   end only:     [end - range, end]
     *   start only:   [start, start + range]
     *   neither:      [now - range, now]
     *
     * Specifying range together with both start and end is an error.
     *
     * @generated from protobuf field: optional string range = 11;
     */
    range?: string;
    /**
     * RE2 regex matched against the logger name; only matching logs are returned.
     * Composes with sources. Served from ClickHouse; the mongo fallback ignores it.
     *
     * @generated from protobuf field: optional string source_filter = 12;
     */
    sourceFilter?: string;
}
/**
 * @generated from protobuf message log.v1.GetRobotPartLogsResponse
 */
export interface GetRobotPartLogsResponse {
    /**
     * @generated from protobuf field: repeated log.v1.LogEntry logs = 1;
     */
    logs: LogEntry[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message log.v1.GetRobotPartLogSourcesRequest
 */
export interface GetRobotPartLogSourcesRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp start = 2;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp end = 3;
     */
    end?: Timestamp;
    /**
     * excludes sources whose logs in the range are all diagnostic
     *
     * @generated from protobuf field: optional bool user_facing_only = 4;
     */
    userFacingOnly?: boolean;
}
/**
 * @generated from protobuf message log.v1.GetRobotPartLogSourcesResponse
 */
export interface GetRobotPartLogSourcesResponse {
    /**
     * @generated from protobuf field: repeated string sources = 1;
     */
    sources: string[];
}
/**
 * LogOrder is the order in which logs are returned, by time.
 *
 * @generated from protobuf enum log.v1.LogOrder
 */
export enum LogOrder {
    /**
     * LOG_ORDER_UNSPECIFIED is treated as LOG_ORDER_DESCENDING.
     *
     * @generated from protobuf enum value: LOG_ORDER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * oldest logs first
     *
     * @generated from protobuf enum value: LOG_ORDER_ASCENDING = 1;
     */
    ASCENDING = 1,
    /**
     * newest logs first
     *
     * @generated from protobuf enum value: LOG_ORDER_DESCENDING = 2;
     */
    DESCENDING = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class LogEntry$Type extends MessageType<LogEntry> {
    constructor() {
        super("log.v1.LogEntry", [
            { no: 1, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "level", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "time", kind: "message", T: () => Timestamp },
            { no: 4, name: "logger_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "caller", kind: "message", T: () => Struct },
            { no: 7, name: "stack", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message log.v1.LogEntry
 */
export const LogEntry = new LogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLogsForMachinePartResourceRequest$Type extends MessageType<GetLogsForMachinePartResourceRequest> {
    constructor() {
        super("log.v1.GetLogsForMachinePartResourceRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sources", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "start_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message log.v1.GetLogsForMachinePartResourceRequest
 */
export const GetLogsForMachinePartResourceRequest = new GetLogsForMachinePartResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLogsForMachinePartResourceResponse$Type extends MessageType<GetLogsForMachinePartResourceResponse> {
    constructor() {
        super("log.v1.GetLogsForMachinePartResourceResponse", [
            { no: 1, name: "logs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LogEntry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message log.v1.GetLogsForMachinePartResourceResponse
 */
export const GetLogsForMachinePartResourceResponse = new GetLogsForMachinePartResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartLogsRequest$Type extends MessageType<GetRobotPartLogsRequest> {
    constructor() {
        super("log.v1.GetRobotPartLogsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "filter", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "levels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "start", kind: "message", T: () => Timestamp },
            { no: 6, name: "end", kind: "message", T: () => Timestamp },
            { no: 7, name: "limit", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 8, name: "sources", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "user_facing_only", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "order", kind: "enum", opt: true, T: () => ["log.v1.LogOrder", LogOrder, "LOG_ORDER_"] },
            { no: 11, name: "range", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "source_filter", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message log.v1.GetRobotPartLogsRequest
 */
export const GetRobotPartLogsRequest = new GetRobotPartLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartLogsResponse$Type extends MessageType<GetRobotPartLogsResponse> {
    constructor() {
        super("log.v1.GetRobotPartLogsResponse", [
            { no: 1, name: "logs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LogEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message log.v1.GetRobotPartLogsResponse
 */
export const GetRobotPartLogsResponse = new GetRobotPartLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartLogSourcesRequest$Type extends MessageType<GetRobotPartLogSourcesRequest> {
    constructor() {
        super("log.v1.GetRobotPartLogSourcesRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start", kind: "message", T: () => Timestamp },
            { no: 3, name: "end", kind: "message", T: () => Timestamp },
            { no: 4, name: "user_facing_only", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message log.v1.GetRobotPartLogSourcesRequest
 */
export const GetRobotPartLogSourcesRequest = new GetRobotPartLogSourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartLogSourcesResponse$Type extends MessageType<GetRobotPartLogSourcesResponse> {
    constructor() {
        super("log.v1.GetRobotPartLogSourcesResponse", [
            { no: 1, name: "sources", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message log.v1.GetRobotPartLogSourcesResponse
 */
export const GetRobotPartLogSourcesResponse = new GetRobotPartLogSourcesResponse$Type();
/**
 * @generated ServiceType for protobuf service log.v1.LogService
 */
export const LogService = new ServiceType("log.v1.LogService", [
    { name: "GetLogsForMachinePartResource", options: {}, I: GetLogsForMachinePartResourceRequest, O: GetLogsForMachinePartResourceResponse },
    { name: "GetRobotPartLogs", options: {}, I: GetRobotPartLogsRequest, O: GetRobotPartLogsResponse },
    { name: "GetRobotPartLogSources", options: {}, I: GetRobotPartLogSourcesRequest, O: GetRobotPartLogSourcesResponse }
]);
